module.exports = __webpack_public_path__ + "static/img/599.411a8d0.png";